import { render } from "./login-footer.vue?vue&type=template&id=ef5eed52&scoped=true"
import script from "./login-footer.vue?vue&type=script&lang=js"
export * from "./login-footer.vue?vue&type=script&lang=js"

import "./login-footer.vue?vue&type=style&index=0&id=ef5eed52&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef5eed52"]])

export default __exports__